import React from 'react';
import { User, Mail, Phone } from 'lucide-react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardSubtitle,
  FormGroup,
  FormSpace,
  Label,
  InputGroup,
  InputIcon,
  Input,
  Button
} from './TeacherJourneyStyles';

interface RegistrationFormProps {
  formData: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  };
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onContinue: () => void;
  loading: boolean;
}

const RegistrationForm: React.FC<RegistrationFormProps> = ({
  formData,
  onInputChange,
  onContinue,
  loading
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Create Teacher Account</CardTitle>
        <CardSubtitle>Enter your personal information to get started</CardSubtitle>
      </CardHeader>

      <FormSpace>
        <FormGroup>
          <Label htmlFor="firstName">First Name</Label>
          <InputGroup>
            <InputIcon>
              <User size={20} />
            </InputIcon>
            <Input
              type="text"
              name="firstName"
              id="firstName"
              value={formData.firstName}
              onChange={onInputChange}
              placeholder="Mary"
              required
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="lastName">Last Name</Label>
          <InputGroup>
            <InputIcon>
              <User size={20} />
            </InputIcon>
            <Input
              type="text"
              name="lastName"
              id="lastName"
              value={formData.lastName}
              onChange={onInputChange}
              placeholder="Atieno"
              required
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="email">Email Address</Label>
          <InputGroup>
            <InputIcon>
              <Mail size={20} />
            </InputIcon>
            <Input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={onInputChange}
              placeholder="mary.atieno@school.edu or mary@gmail.com"
              required
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="phone">Phone Number</Label>
          <InputGroup>
            <InputIcon>
              <Phone size={20} />
            </InputIcon>
            <Input
              type="tel"
              name="phone"
              id="phone"
              value={formData.phone}
              onChange={onInputChange}
              placeholder=" eg 0768xxxxxx"
              required
            />
          </InputGroup>
        </FormGroup>

        <Button
          onClick={onContinue}
          disabled={loading || !formData.firstName || !formData.lastName || !formData.email || !formData.phone}
        >
          {loading ? 'Processing...' : 'Continue'}
        </Button>
      </FormSpace>
    </Card>
  );
};

export default RegistrationForm; 